export default __webpack_public_path__ + "static/media/(12).de96a95f.jpg";